'use client';
import { useTranslations } from 'next-intl';
import { type FC, useEffect, useState } from 'react';
import { CustomPagination } from '@/app/components/shared/CustomPagination';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/app/components/ui/dialog';
import { useFetch } from '@/app/hooks';
import { reportEvent } from '@/app/utils';
import { ordersListHistory } from '../../apis';
import { PAGE_SIZE } from '../../constants';
import { OrderTable } from './OrderTable';

export const OrderList: FC = () => {
  const t = useTranslations();
  const [page, setPage] = useState<number>(1);

  const { loading, data } = useFetch(
    () =>
      ordersListHistory({
        query: {
          'pager.page': page - 1,
          'pager.pagesz': PAGE_SIZE,
        },
      }),
    {
      refreshDeps: [page],
    },
  );

  return (
    <>
      <OrderTable orders={data?.data?.orders || []} loading={loading} total={data?.data?.total || 0} />
      <div className="relative h-9">
        <div className="-translate-y-1/2 absolute top-1/2 left-0 font-medium text-sm text-system-text03 sm:hidden">
          {t('payments.orderList.pageRecord', { num: PAGE_SIZE })}
        </div>
        <CustomPagination
          currentPage={page}
          total={data?.data?.total || 0}
          pageSize={PAGE_SIZE}
          onPageChange={(page: number) => setPage(page)}
        />
      </div>
    </>
  );
};

export const OrderListDialog: FC<{ open: boolean; onOpenChange: (open: boolean) => void }> = ({
  open,
  onOpenChange,
}) => {
  const t = useTranslations();
  useEffect(() => {
    reportEvent('order_modal_expsure');
  }, []);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[1080px] max-w-[1080px]">
        <DialogHeader>
          <DialogTitle>{t('payments.orderList.title')}</DialogTitle>
        </DialogHeader>
        <OrderList />
      </DialogContent>
    </Dialog>
  );
};
